
  document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
      const starsContainer = document.querySelector('.star-container')?.parentElement?.parentElement;

      if (starsContainer && !starsContainer.querySelector('.custom-rating-text')) {
        document.querySelectorAll('.star-container').forEach((span, index) => {
          if(index == 4) {
            
            span.classList.remove('yotpo-sr-star-empty');
            span.classList.add('yotpo-sr-star-half');
            span.innerHTML= `<defs>
		    <linearGradient id="yotpo_stars_gradient_0.8563926457371702">
		        <stop offset="51%" stop-color="#F0CD66"></stop>
		        <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
			</linearGradient>
		</defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.8563926457371702')"></path>`;
          } else {
            span.classList.remove('yotpo-sr-star-empty');
            span.classList.add('yotpo-sr-star-full');
            span.innerHTML= `<defs>
                <linearGradient id="yotpo_stars_gradient_0.28508708046692344">
                    <stop offset="100%" stop-color="#F0CD66"></stop>
                    <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
              </linearGradient>
            </defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.28508708046692344')"></path>`;
          }
          
        });
        const textEl = document.createElement('span');
        textEl.className = 'custom-rating-text';
        // textEl.textContent = 'Rated 4.8 out of 5 stars';
        textEl.textContent = ' Rated 4.8/5 Stars';
       
        starsContainer.appendChild(textEl);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  (function () {
    const DESIRED_SCORE = "4.8";

    function patchYotpo(root = document) {
      let changed = 0;

      // === First existing patch ===
      root.querySelectorAll(".yotpo-regular-box .bottom-line-items").forEach(box => {
        if (box.dataset.patched === "1") return; 

        const avg = box.querySelector(".avg-score.font-color-gray-darker");
        if (avg) {
          avg.textContent = DESIRED_SCORE;
          avg.setAttribute("aria-label", `${DESIRED_SCORE} star rating`);
          changed++;
        }

        box.dataset.patched = "1";
      });

      // === New patch for yotpo-summary-section ===
      root.querySelectorAll(".yotpo-summary-section").forEach(section => {
        if (section.dataset.patched === "1") return;

        // Left panel number
        const leftPanel = section.querySelector(".yotpo-bottom-line-left-panel.yotpo-bottom-line-score");
        if (leftPanel) {
          leftPanel.textContent = DESIRED_SCORE;
          changed++;
        }

        section.dataset.patched = "1";
      });

      return changed;
    }

    function run() { patchYotpo(); }

    document.addEventListener("DOMContentLoaded", run);
    window.addEventListener("load", run);

    const obs = new MutationObserver(() => {
      clearTimeout(window.__yotpoPatchTimer);
      window.__yotpoPatchTimer = setTimeout(run, 50);
    });
    obs.observe(document.body, { childList: true, subtree: true });

    document.addEventListener("shopify:section:load", run);
    document.addEventListener("shopify:section:unload", run);
  })();


  document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (e) {
      const btn = e.target.closest(".yotpo-sr-bottom-line-summary");
      if (btn) {
        e.preventDefault();
        const reviewSection = document.querySelector(".yotpo-widget-instance-custom");
        if (reviewSection) {
          reviewSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  });


  document.addEventListener("DOMContentLoaded", function () {
    const stickyBtnWrapper = document.querySelector(".stickybtn");
    const testimonialSection = document.querySelector(".section-testimonials-slider");
    if (!stickyBtnWrapper || !testimonialSection) return;

    stickyBtnWrapper.classList.add("is-hidden");

    function getTriggerTop() {
      return testimonialSection.getBoundingClientRect().top + window.scrollY;
    }

    let triggerTop = getTriggerTop();

    function onScrollOrResize() {
      triggerTop = getTriggerTop();

      const bottomOfViewport = window.scrollY + window.innerHeight;

      if (bottomOfViewport >= triggerTop) {
        stickyBtnWrapper.classList.remove("is-hidden");
      } else {
        stickyBtnWrapper.classList.add("is-hidden");
      }
    }

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);
    window.addEventListener("load", onScrollOrResize);

    setTimeout(onScrollOrResize, 400);
  });

// (function () {
//   function syncYotpoReviews(root = document) {
//     let changed = 0;

//     // Find "Based on XXX reviews"
//     const baseText = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (baseText) {
//       const match = baseText.textContent.match(/Based on\s+(\d+)\s+reviews/i);
//       if (match) {
//         const reviewCount = match[1]; // 348 javu number
//         // Find right side reviews text (like "58 Reviews")
//         root.querySelectorAll(".yotpo-sr-bottom-line-text--right-panel").forEach(span => {
//           if (span.dataset.patched === "1") {return};
//           span.textContent = `${reviewCount} Reviews`;
//           span.dataset.patched = "1";
//           changed++;
//         });
//       }
//     }

//     return changed;
//   }

//   function run() { syncYotpoReviews(); }

//   document.addEventListener("DOMContentLoaded", run);
//   window.addEventListener("load", run);

//   // Watch for Yotpo re-render
//   const obs = new MutationObserver(() => {
//     clearTimeout(window.__yotpoReviewPatchTimer);
//     window.__yotpoReviewPatchTimer = setTimeout(run, 50);
//   });
//   obs.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload events
//   document.addEventListener("shopify:section:load", run);
//   document.addEventListener("shopify:section:unload", run);
// })();



(function () {
  function syncYotpoReviews(root = document) {
    let changed = 0;
    // Find "Based on XXX reviews"
    const baseText = root.querySelector(".yotpo-bottom-line-basic-text");
    if (baseText) {
      const match = baseText.textContent.match(/Based on\s+(\d+)\s+reviews/i);
      if (match) {
        const reviewCount = match[1];
        root.querySelectorAll(".yotpo-sr-bottom-line-text--right-panel").forEach(span => {
          if (span.dataset.patched === "1") return;
          span.textContent = `${reviewCount} Reviews`;
          span.dataset.patched = "1";
          changed++;
        });
      }
    }

    if (changed > 0) {
      // Reveal widget only after patching
      document.querySelectorAll(".yotpo-widget-instance").forEach(el => {
        el.classList.add("yotpo-ready");
      });
    }
    return changed;
  }

  function run() { syncYotpoReviews(); }
  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
  // Watch for Yotpo re-render
  const obs = new MutationObserver(() => {
    clearTimeout(window.__yotpoReviewPatchTimer);
    window.__yotpoReviewPatchTimer = setTimeout(run, 50);
  });
  obs.observe(document.body, { childList: true, subtree: true });
  // Shopify section reload events
  document.addEventListener("shopify:section:load", run);
  document.addEventListener("shopify:section:unload", run);

})();


(function () {
  function patchYotpoRating(root = document) {
    const ratingEl = root.querySelector(".yotpo-bottom-line-left-panel.yotpo-bottom-line-score");
    if (ratingEl && ratingEl.dataset.patched !== "1") {
      ratingEl.childNodes.forEach(node => {
        if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
          node.textContent = "4.8"; // 👈 forced rating
        }
      });
      ratingEl.dataset.patched = "1";
    }
  }

  function run() { patchYotpoRating(); }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);

  const obs = new MutationObserver(() => {
    clearTimeout(window.__yotpoPatchTimer);
    window.__yotpoPatchTimer = setTimeout(run, 50);
  });
  obs.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("shopify:section:load", run);
})();

(function () {
  function patchYotpoBasedOn(root = document) {
    const el = root.querySelector(".yotpo-bottom-line-basic-text");
    if (el && el.dataset.cleaned !== "1") {
      el.textContent = el.textContent.replace(/^Based on\s*/i, ""); // remove "Based on "
      el.dataset.cleaned = "1";
    }
  }

  function run() { patchYotpoBasedOn(); }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);

  // re-check if Yotpo re-renders
  const obs = new MutationObserver(() => {
    clearTimeout(window.__yotpoPatchTimer2);
    window.__yotpoPatchTimer2 = setTimeout(run, 50);
  });
  obs.observe(document.body, { childList: true, subtree: true });

})();



// old -review js
//   document.addEventListener("DOMContentLoaded", function () {
//     const observer = new MutationObserver(() => {
//       const starsContainer = document.querySelector('.star-container')?.parentElement?.parentElement;

//       if (starsContainer && !starsContainer.querySelector('.custom-rating-text')) {
//         document.querySelectorAll('.star-container').forEach((span, index) => {
//           if(index == 4) {
            
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-half');
//             span.innerHTML= `<defs>
// 		    <linearGradient id="yotpo_stars_gradient_0.8563926457371702">
// 		        <stop offset="51%" stop-color="#F0CD66"></stop>
// 		        <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
// 			</linearGradient>
// 		</defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.8563926457371702')"></path>`;
//           } else {
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-full');
//             span.innerHTML= `<defs>
//                 <linearGradient id="yotpo_stars_gradient_0.28508708046692344">
//                     <stop offset="100%" stop-color="#F0CD66"></stop>
//                     <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
//               </linearGradient>
//             </defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.28508708046692344')"></path>`;
//           }
          
//         });
//         const textEl = document.createElement('span');
//         textEl.className = 'custom-rating-text';
//         textEl.textContent = 'Rated 4.8 out of 5 stars';
//         starsContainer.appendChild(textEl);
//       }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
//   });

//   (function () {
//     const DESIRED_SCORE = "4.8";

//     function patchYotpo(root = document) {
//       let changed = 0;

//       // === First existing patch ===
//       root.querySelectorAll(".yotpo-regular-box .bottom-line-items").forEach(box => {
//         if (box.dataset.patched === "1") return; 

//         const avg = box.querySelector(".avg-score.font-color-gray-darker");
//         if (avg) {
//           avg.textContent = DESIRED_SCORE;
//           avg.setAttribute("aria-label", `${DESIRED_SCORE} star rating`);
//           changed++;
//         }

//         box.dataset.patched = "1";
//       });

//       // === New patch for yotpo-summary-section ===
//       root.querySelectorAll(".yotpo-summary-section").forEach(section => {
//         if (section.dataset.patched === "1") return;

//         // Left panel number
//         const leftPanel = section.querySelector(".yotpo-bottom-line-left-panel.yotpo-bottom-line-score");
//         if (leftPanel) {
//           leftPanel.textContent = DESIRED_SCORE;
//           changed++;
//         }

//         section.dataset.patched = "1";
//       });

//       return changed;
//     }

//     function run() { patchYotpo(); }

//     document.addEventListener("DOMContentLoaded", run);
//     window.addEventListener("load", run);

//     const obs = new MutationObserver(() => {
//       clearTimeout(window.__yotpoPatchTimer);
//       window.__yotpoPatchTimer = setTimeout(run, 50);
//     });
//     obs.observe(document.body, { childList: true, subtree: true });

//     document.addEventListener("shopify:section:load", run);
//     document.addEventListener("shopify:section:unload", run);
//   })();


//   document.addEventListener("DOMContentLoaded", function () {
//     document.body.addEventListener("click", function (e) {
//       const btn = e.target.closest(".yotpo-sr-bottom-line-summary");
//       if (btn) {
//         e.preventDefault();
//         const reviewSection = document.querySelector(".yotpo-widget-instance-custom");
//         if (reviewSection) {
//           reviewSection.scrollIntoView({ behavior: "smooth", block: "start" });
//         }
//       }
//     });
//   });


//   document.addEventListener("DOMContentLoaded", function () {
//     const stickyBtnWrapper = document.querySelector(".stickybtn");
//     const testimonialSection = document.querySelector(".section-testimonials-slider");
//     if (!stickyBtnWrapper || !testimonialSection) return;

//     stickyBtnWrapper.classList.add("is-hidden");

//     function getTriggerTop() {
//       return testimonialSection.getBoundingClientRect().top + window.scrollY;
//     }

//     let triggerTop = getTriggerTop();

//     function onScrollOrResize() {
//       triggerTop = getTriggerTop();

//       const bottomOfViewport = window.scrollY + window.innerHeight;

//       if (bottomOfViewport >= triggerTop) {
//         stickyBtnWrapper.classList.remove("is-hidden");
//       } else {
//         stickyBtnWrapper.classList.add("is-hidden");
//       }
//     }

//     window.addEventListener("scroll", onScrollOrResize, { passive: true });
//     window.addEventListener("resize", onScrollOrResize);
//     window.addEventListener("load", onScrollOrResize);

//     setTimeout(onScrollOrResize, 400);
//   });

// (function () {
//   function syncYotpoReviews(root = document) {
//     let changed = 0;

//     // Find "Based on XXX reviews"
//     const baseText = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (baseText) {
//       const match = baseText.textContent.match(/Based on\s+(\d+)\s+reviews/i);
//       if (match) {
//         const reviewCount = match[1]; // 348 javu number
//         // Find right side reviews text (like "58 Reviews")
//         root.querySelectorAll(".yotpo-sr-bottom-line-text--right-panel").forEach(span => {
//           if (span.dataset.patched === "1") {return};
//           span.textContent = `${reviewCount} Reviews`;
//           span.dataset.patched = "1";
//           changed++;
//         });
//       }
//     }

//     return changed;
//   }

//   function run() { syncYotpoReviews(); }

//   document.addEventListener("DOMContentLoaded", run);
//   window.addEventListener("load", run);

//   // Watch for Yotpo re-render
//   const obs = new MutationObserver(() => {
//     clearTimeout(window.__yotpoReviewPatchTimer);
//     window.__yotpoReviewPatchTimer = setTimeout(run, 50);
//   });
//   obs.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload events
//   document.addEventListener("shopify:section:load", run);
//   document.addEventListener("shopify:section:unload", run);
// })();

// (function () {
//   function patchYotpoRating(root = document) {
//     const ratingEl = root.querySelector(".yotpo-bottom-line-left-panel.yotpo-bottom-line-score");
//     if (ratingEl && ratingEl.dataset.patched !== "1") {
//       ratingEl.childNodes.forEach(node => {
//         if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
//           node.textContent = "4.8"; // 👈 forced rating
//         }
//       });
//       ratingEl.dataset.patched = "1";
//     }
//   }

//   function run() { patchYotpoRating(); }

//   document.addEventListener("DOMContentLoaded", run);
//   window.addEventListener("load", run);

//   const obs = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer);
//     window.__yotpoPatchTimer = setTimeout(run, 50);
//   });
//   obs.observe(document.body, { childList: true, subtree: true });

//   document.addEventListener("shopify:section:load", run);
// })();

// (function () {
//   function patchYotpoBasedOn(root = document) {
//     const el = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (el && el.dataset.cleaned !== "1") {
//       el.textContent = el.textContent.replace(/^Based on\s*/i, ""); // remove "Based on "
//       el.dataset.cleaned = "1";
//     }
//   }

//   function run() { patchYotpoBasedOn(); }

//   document.addEventListener("DOMContentLoaded", run);
//   window.addEventListener("load", run);

//   // re-check if Yotpo re-renders
//   const obs = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer2);
//     window.__yotpoPatchTimer2 = setTimeout(run, 50);
//   });
//   obs.observe(document.body, { childList: true, subtree: true });

// })();

